<ng-container #primarySlot></ng-container>
<div class="label">
  <rt-icon [name]="iconName" [size]="iconSize"> </rt-icon>
</div>
<ng-container #secondarySlot></ng-container>
